'use client';
import React from 'react';
import Button from '../ui/button';
import Image from 'next/image';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { Product } from '@/types/product_page/productType';
import { openChatwoot } from '../shared/chatwoot';
import { getRegionalUrl } from '@/lib/utils';

const Chat = ({ data, content }: { data?: Product | null; content: any }) => {
  const params = useParams<{ countryCode?: string }>();
  return (
    <div className="w-full bg-[#000] overflow-hidden flex justify-between rounded-[10px] relative font-proxima_font">
      <div className="flex flex-col p-6 text-white z-[2] relative flex-shrink-0">
        <h3 className="font-bold text-lg mb-2">
          {content?.have_question_title || 'Have Questions?'}
        </h3>
        <p className="text-sm">
          {content?.have_question_sub_title || 'Our experts are ready to help.'}
        </p>
        {content?.chat && (
          <Button
            label="Chat Now"
            onClick={openChatwoot}
            variant="white"
            className="py-2 px-7 mt-4 bg-white text-black hover:border-white"
          />
        )}

        <Link
          href={getRegionalUrl(
            data?.has_support_page
              ? `/support/productSupport/?name=${data.handle}`
              : '/support/contact-us',
            params?.countryCode
          )}
        >
          <p className="flex group gap-1 underline underline-offset-8 mt-4 font-semibold text-xs sm:text-sm">
            {data?.has_support_page ? ' Get product support' : 'Contact Us'}
            <span className="group-hover:translate-x-2 transition-transform duration-300">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={18}
                height={18}
                viewBox="0 0 24 24"
              >
                <path
                  d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </p>
        </Link>
      </div>
      <div className="flex flex-col justify-end absolute top-0 md:right-5 right-2 bottom-0 z-[1]">
        <Image
          src={
            content?.have_question_bg
              ? `${process.env.NEXT_PUBLIC_BASE_URL}/assets/${content?.have_question_bg}`
              : '/assets/product/chat-banner.webp'
          }
          alt="George"
          width={200}
          height={200}
          className="w-48 sm:w-52 h-full object-contain object-top"
        />
      </div>
    </div>
  );
};

export default Chat;
